import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
type OfferButtonProps = {
  children: React.ReactNode;
  href?: string;
  onClick?: () => void;
  className?: string;
  small?: boolean;
};
export function OfferButton({
  children,
  href,
  onClick,
  className = '',
  small = false
}: OfferButtonProps) {
  const sharedClassName = `group inline-flex items-center justify-center gap-3 rounded-full bg-[#a95848] font-bold uppercase tracking-[0.1em] text-white shadow-[0_12px_28px_rgba(92,54,44,0.18)] transition hover:bg-[#873f32] focus:outline-none focus:ring-4 focus:ring-[#dba89b]/40 ${small ? 'px-5 py-3 text-[10px]' : 'w-full px-6 py-4 text-xs sm:w-auto sm:px-8'} ${className}`;
  if (href) {
    return <a className={sharedClassName} href={href} onClick={onClick} data-id="element-8">
        <span data-id="element-9">{children}</span>
        <ArrowRightIcon aria-hidden="true" className="h-4 w-4 transition-transform group-hover:translate-x-0.5" data-id="element-10" />
      </a>;
  }
  return <button className={sharedClassName} type="button" onClick={onClick} data-id="element-11">
      <span data-id="element-12">{children}</span>
      <ArrowRightIcon aria-hidden="true" className="h-4 w-4 transition-transform group-hover:translate-x-0.5" data-id="element-13" />
    </button>;
}